import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { AppState } from '../../../../core/reducers';
import {
  selectInterventionHistoryInStore,
  selectInterventionHistoryPageLoading,
  selectInterventionHistoryShowInitWaitingMessage,
} from '../selectors/intervention-histoy.selectors';

export class InterventionHistoryDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectInterventionHistoryPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectInterventionHistoryShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectInterventionHistoryInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
